import React from 'react';
import { nlBr } from '@sizeid/commons/utils/strings';
import Box from '@sizeid/commons/components/Box';
import Button from '@sizeid/commons/components/Button';
import { SIGN_INDEX } from '@sizeid/shared/constants/routes';

import app from 'components/app';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import SectionBottomImage from 'components/Page/Section/SectionBottomImage';
import Wrapper from 'components/Page/Wrapper';
import H1 from 'components/typo/Heading/H1';
import H2 from 'components/typo/Heading/H2';
import P from 'components/typo/P';
import Features from 'components/Features';
import RouteLink from 'components/RouteLink';
import { useTranslation } from 'lib/i18n';

import beach from './images/About-header-background.jpg';
import planet from './images/illustration_planet.svg';
import jump from './images/SizeID_about_jump.svg';
import advisor from './images/img_advisor.svg';
import friends from './images/img_friends.svg';
import AboutTopWrap from './AboutTopWrap';
import SemiTransparentBox from './SemiTransparentBox';
import AboutBigImage from './AboutBigImage';

const About: React.FC = () => {
  const { t } = useTranslation('pages');
  return (
    <Page title={t('about.title')} footer noPadding>
      <>
        <Section background={beach}>
          <>
            <Wrapper css="min-height: 400px;">
              <AboutTopWrap>
                <SemiTransparentBox>
                  <H1>{t('about.h1')}</H1>
                  <P dark>{t('about.description')}</P>
                </SemiTransparentBox>
                <img src={jump} alt="" />
              </AboutTopWrap>
            </Wrapper>
            <SectionBottomImage src={planet} alt="" width={120} />
          </>
        </Section>
        <Section white beforeWave topWave>
          <Wrapper>
            <>
              <H2>{nlBr(t('about.industry.title'))}</H2>
              <P bigOnDesktop lead>
                {t('about.industry.text')}
              </P>
              <Features
                base="about.industry.features"
                keys={['company', 'shop', 'organizations', 'customers']}
                imageSize={80}
              />
            </>
          </Wrapper>
        </Section>
        <Section gray beforeWave topWave flipTopWave>
          <Wrapper>
            <>
              <H2>{nlBr(t('about.sizeid_profile.title'))}</H2>
              <P dark bigOnDesktop>
                {t('about.sizeid_profile.text')}
              </P>
              <Features
                base="about.sizeid_profile.features"
                keys={['meter', 'click']}
                imageSize={90}
              />
            </>
          </Wrapper>
        </Section>
        <Section white topWave>
          <Wrapper>
            <>
              <AboutBigImage src={advisor} height="110px" alt="" />
              <H2>{t('about.start_using_sizeid.advisor.title')}</H2>
              <P bigOnDesktop>{t('about.start_using_sizeid.advisor.text')}</P>
              <AboutBigImage src={friends} alt="" />
              <H2>{t('about.start_using_sizeid.friends.title')}</H2>
              <P bigOnDesktop>{t('about.start_using_sizeid.friends.text')}</P>
              <Box paddingTop={4} display="block">
                <RouteLink
                  href={{
                    pathname: SIGN_INDEX.route,
                    query: { signFormsTab: 1 },
                  }}
                  passHref
                >
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                  <a>
                    <Button giant>
                      {t('about.start_using_sizeid.button')}
                    </Button>
                  </a>
                </RouteLink>
              </Box>
            </>
          </Wrapper>
        </Section>
      </>
    </Page>
  );
};

export default app(About);
